// SCREENS.md "Offline fallback (SW navigateFallback when shell uncached)": shown when a
// navigation errors out while offline (eg. a lazy route chunk that never got precached) —
// full-screen, honest about connectivity, never blank (§11.11). Rendered by
// RouteErrorBoundary's offline branch (routes.tsx errorElement) — never used directly
// as an errorElement, since an error while online must NOT show connectivity copy.
export function OfflineScreen() {
  return (
    <main className="screen-form offline-screen">
      <h1>Reconnecting…</h1>
      <p className="form-note">Project Pets couldn&rsquo;t load this page without a connection.</p>
      <div className="actions">
        <button className="btn-primary" onClick={() => window.location.reload()}>
          Try again
        </button>
      </div>
    </main>
  );
}
